import React from 'react'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import { handleKeyboardAction } from './keyboard'
import type { usePainterWorkOrderStyles } from './usePainterWorkOrderStyles'
import classNames from 'classnames'

interface SummaryToggleRowProps {
  label: string
  expanded: boolean
  onToggle: () => void
  classes: ReturnType<typeof usePainterWorkOrderStyles>
}

export default function SummaryToggleRow({ label, expanded, onToggle, classes }: SummaryToggleRowProps) {
  return (
    <div
      className={classNames({ [classes.summaryRow]: true, [classes.summaryRowExpanded]: expanded })}
      onClick={onToggle}
      onKeyDown={(event) => handleKeyboardAction(event, onToggle)}
      role="button"
      tabIndex={0}
    >
      <span className={classes.summaryRowLabel}>{label}</span>
      <div className={classes.summaryRowValue}>
        {expanded ? (
          <KeyboardArrowUpIcon className={classes.summaryRowIcon} />
        ) : (
          <KeyboardArrowDownIcon className={classes.summaryRowIcon} />
        )}
      </div>
    </div>
  )
}
